import callApi from '.';

export const fetchAllRoles = () => {
    const endpoint = '/api/roles';
    return callApi(endpoint);
};
